<template lang="pug">
  .autocomplete(
    ref="parent"
    v-bind:class="{ inline: inline }"
  )
    //md-field( v-bind:class="{'md-invalid': error || errors.first('isSelected')}")
      label {{label}}
      md-input(
          v-model="searchString"
          v-on:focus="onFocus"
          v-on:blur="onBlur"
          v-bind:disabled="disabled"
          v-bind:placeholder="this.$props.placeholder"
          autocomplete="off"
          ref="input"
      )
    .autocomplete-container
      z-input(
        v-bind:name="name" 
        v-bind:id="$props.id" 
        v-bind:label="$props.label" 
        v-model="searchString" 
        v-bind:error="inputError"
        v-bind:mask="$props.mask"
        v-on:focus="onFocus"
        v-bind:disabled="disabled || isSelected"
        v-bind:loading="loading"
        v-bind:inline="inline"
        ref="input"
        autocomplete="off"
      )
      md-progress-bar#progress-bar.md-accent(md-mode="indeterminate" v-show="loading" style="top: 50px; height: 2px; z-index: 900; position: absolute;")
      .button-bar(v-if="!$props.disabled")
        .btn(v-on:click="onClear" v-show="isSelected")
          i.fa.fa-times
        .btn(v-on:click="onSave" v-show="$props.showSaveBtn && isSelected")
          i.fas.fa-check
      .list(v-show="showMenu" ref="list")
        .item(v-for="(item, index) in findResult" v-bind:key="index" v-on:click="selectItem(item, $event)")
          span {{item[listDisplayProperty]}}
      input(v-if="$props.required" type="checkbox" name="isSelected" v-model="isSelected" v-validate="'required'" data-vv-as=" " style="visibility: hidden; display: none;")
</template>
<script>
  import ZInput from '@/components/ZInput'
  export default {
    components: {ZInput},
    name: 'autocomplete',
    props: [
      'placeholder',
      'items',    //массив с объектами элементов, по которым будет идти поиск - [{id: 1, name: 'name 1'}, {id: 2, name: 'name 2'}]
      'property', //свойство объектов в массиве, по значению которого будет идти поиск - name
      'display-property', //свойство объектов в массиве, коорое будет выводиться в списке поиска
      'return',   //свойство объектов в массиве, значене которого будет возвращаться в качестве результата - id
      'return-all', //если передать true, то будет возвращать не поле объекта, а весь объект
      'clear-after-select', //если передать true, поле поиска будет очищаться после выбора
      'label',    //заголовок для поля
      'value',    //значение поля, должно быть = свойству, указнному в return, для одного из элементов - 2
      'callback', //функция, которая возвращает список для автозаполнения
      'default',   //текстовое значение поля, если используется callback,
      'showOnFocus', //если установенно в true, то выпадающий список будет показываться по фокусу на инпуте, для этого обязательно указывать параметр items
      'disabled',
      'error',
      'fixed',
      'required', //позиционировать выпадающее меню относительно окна
      'id',
      'name',
      'deafaultObject',
      'mask',
      'searchLength',
      'showSaveBtn',
      'inline',
      'updateOnInput'
    ],
    data() {
      return {
        searchString: '',
        findResult: [],
        showMenu: false,
        isFocused: false,
        listDisplayProperty: 'name',
        mdCloseOnClick: false,
        mdCloseOnSelect: false,
        loading: false,
        isSelected: false,
        blurListener: null
      }
    },
    created() {
      this.$nextTick(() => {
          if (!this.callback || this.showOnFocus) this.findResult = Object.assign([], this.$props.items);
          if (this.$props.displayProperty || this.$props.property)
              this.listDisplayProperty = (this.$props.displayProperty) ? this.$props.displayProperty : this.$props.property;
      });
      
      if (this.$props.deafaultObject) this.selectItem(this.$props.deafaultObject);
      else this.searchString = (this.default) ? this.default : '';
    
      this.checkSelect();
      this.position();
    },
    computed: {
      fixedPosition() {
        return typeof this.fixed == 'undefined' || this.fixed
      },
      inputError() {
        return (this.errors.has('isSelected')) ? 'Необходимо выбрать значение из списка' : this.$props.error
      }
    },
    methods: {
      validateClear() {
        this.errors.clear();
        this.$validator.errors.clear();
        this.$validator.reset();
      },
      listeners() {
        this.blurListener = document.addEventListener('click', e => {
            if (this.$refs && this.$refs.parent && !this.$refs.parent.contains(e.target)) this.onBlur();
        });
      },
      onFocus(e) {
        this.listeners();
        this.position();
        this.isFocused = true;
        if (this.showOnFocus) {
            this.findResult = Object.assign([], this.$props.items);
            this.showMenu = true;
        }
      },
      onBlur(e) {
          //setTimeout(() => {
            document.removeEventListener('click', this.blurListener, false);
            this.isFocused = false;
            this.showMenu  = false;
            this.$emit('blur');
            this.$validator.validateAll();
          //}, 100);
      },
      onSave() {
        this.$emit('save');
      },
      onClear() {
        this.isSelected = false;
        this.searchString = null;
        this.$emit('clear');
      },
      start() {
        if (!this.isFocused) return;
        //если передали массив с элементами, то сделаем поиск по ним и выберем подходящий элемент
        if (this.$props.items && Object.keys(this.$props.items).length && this.value) {
          this.findResult = [];
          Object.keys(this.$props.items).forEach((key) => {
            let item = this.$props.items[key];
            if (item[this.return] === this.value) this.findResult.push(item);
          });
          //if (this.findResult.length) this.showMenu = true;
        }
      },
      search() {
        if (!this.isFocused) return;
        this.findResult = [];
        if (this.callback && typeof this.callback === 'function' ) {
          if (!this.loading) {
              this.loading = true;
              this.callback(this.searchString).then(result => {
                  if (result.body && result.body.response) {
                      if (result.body.response.data) this.findResult = Object.assign([], result.body.response.data);
                      else this.findResult = Object.assign([], result.body.response);
                  } else this.findResult = Object.assign([], result);
                  if (Object.keys(this.findResult).length) this.showMenu = true;
                  this.loading = false;
              }).finally(() => this.loading = false);
          }
        } else {
          if (Object.keys(this.$props.items).length && this.searchString) {
            Object.keys(this.$props.items).forEach((key) => {
              let item = this.$props.items[key];
              if ((item[this.property].toLowerCase().indexOf(this.searchString.toLowerCase()) + 1)) this.findResult.push(item);
            });
          }
          if (!this.searchString || !this.searchString.length) this.findResult = this.$props.items;
          if(Object.keys(this.findResult).length) this.showMenu = true;
        }
      },
      selectItem(item, $event) {
        this.$nextTick(() => {
            let result;
            if (this.returnAll) result = item;
            else result = item[this.return];

            this.$emit('select', result, Object.assign({}, item));
            this.$emit('input', result);


            this.$nextTick(() => {
              this.findResult = [];
              if (this.clearAfterSelect) this.searchString = '';
              this.isSelected = true;
              this.onBlur();
            });
        });
      },
      position() {
        /*
        if (this.fixedPosition) {
          this.$nextTick(() => {
            let parent = this.$refs.parent;
            let list = this.$refs.list;
            let width = parent.offsetWidth;
            let height = parent.offsetHeight;
            let left = parent.getBoundingClientRect().left;
            let top = parseInt(parent.getBoundingClientRect().top) + parseInt(height);
            list.style.width = width + 'px';
            list.style.left = left + 'px';
            list.style.top = top + 'px';
            list.style.zIndex = 100;
            document.querySelector('body').appendChild(list);
          });
        }
        */
      },
      select(value) {
        if (value) this.searchString = value;
        this.isSelected = true;
        this.onBlur();
      },
      checkSelect() {
        this.$nextTick(() => {
          if (!this.isFocused && this.default) this.isSelected = true;
        });
      }
    },
    watch: {
      'searchString'(value, oldValue) {
        if (!value) this.$emit('input', null);
        if (this.$props.updateOnInput) this.$emit('input', value);
        if (this.$props.deafaultObject) return;
        this.position();
        this.isSelected = false;
        //this.isFocused  = true;

        setTimeout(() => {
          if (value == this.searchString) {
            let stringLength = (this.$props.searchLength) ? this.$props.searchLength : 3;
            if (value && value.length >= stringLength && this.isFocused && !this.loading) this.search();
          }
        }, 1000);

        //if (!this.$props.return || this.$props.property == this.$props.return) this.$emit('input', value);
        //if (this.$props.displayProperty == this.$props.return) this.$emit('input', value);
      },
      '$props.value'(value) {
        this.position();
        if (value != this.searchString) this.start();
        this.checkSelect();
      },
      'default'(value) {
        this.searchString = this.default;
        //если инпут не выделен, значит сработало автозаполнение с другого инпута
        //и можно выставить флаг выбора
        this.checkSelect();
      },
      //отслеживаем обновление списка элементов, т.к. он не всегда доступен сразу при создании компонента
      '$props.items'(items) {
        this.position();
        if (!this.callback) this.findResult = this.$props.items;
        if (items && items.length) this.start();
      },
      '$props.deafaultObject'(deafaultObject) {
        if (deafaultObject) this.$nextTick(() => this.selectItem(deafaultObject));
      }
    }
  }
</script>
<style scoped lang="sass">
  .autocomplete
    width: 100%
    .autocomplete-container
      position: relative
      .button-bar
        position: absolute
        z-index: 15
        right: 2px
        bottom: 2px
        height: 26px
        display: flex
        align-items: center
        justify-content: flex-end
        .btn
          height: 22px
          width: 22px
          display: flex
          align-items: center
          justify-content: center
          cursor: pointer
          border-radius: 100%
          transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1)
          will-change: background-color,opacity
          margin: 0 0 0 5px
          &:hover
            background: rgba(33, 33, 33, 0.12)
          svg
            display: block
            width: 14px
            height: 14px
            font-size: 15px
            line-height: 14px
            box-sizing: border-box
            vertical-align: baseline
    .md-menu
      width: 100%
      .md-input
        width: 100%
    .list
      position: absolute
      background: #fff
      box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)
      z-index: 1000
      top: 51px
      min-width: 100%
      &.fixed
        position: fixed
        min-width: initial
      .item
        padding: 2px 10px
        font-size: 12px
        line-height: 14px
        transition: .3s cubic-bezier(.4,0,.2,1);
        cursor: pointer
        &:hover
          background: var(--md-theme-white-highlight-on-background, rgba(0, 0, 0, 0.08))
    &.inline
      .button-bar
        top: 2px
  .autocomplete.inline
    .list
      margin-left: 40%
      min-width: 60%
      top: 26px
</style>



// WEBPACK FOOTER //
// autocomplete.vue?540ae8d6